import { request } from '@/shared/api/request'

export const decline = async (externalId, note) => {
	return request({ url: `colcontract/ecd/employer/reject/${externalId}?note=${note}`, method: 'POST' })
}
